module.exports = __webpack_public_path__ + "static/10-9c2e3f39c54cd90b61b78fe319cb3e1b.png";